import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Play, Clock, Calendar } from 'lucide-react';

const HoopsRecapsPage: React.FC = () => {
  const recaps = [
    {
      id: 1,
      title: 'Lakers vs Warriors - Epic Showdown',
      date: '2024-01-15',
      duration: '8:32',
      description: 'LeBron leads Lakers to victory in overtime thriller',
      thumbnail: '/api/placeholder/320/180',
      views: '2.4K'
    },
    {
      id: 2,
      title: 'Celtics Dominate Heat in Playoffs',
      date: '2024-01-14',
      duration: '12:15',
      description: 'Tatum scores 40 points in dominant performance',
      thumbnail: '/api/placeholder/320/180',
      views: '3.1K'
    },
    {
      id: 3,
      title: 'Nuggets Championship Run Continues',
      date: '2024-01-13',
      duration: '15:20',
      description: 'Jokic triple-double leads Denver to victory',
      thumbnail: '/api/placeholder/320/180',
      views: '1.8K'
    }
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Basketball Hoops Recaps</h1>
          <p className="text-gray-600">Latest game highlights and analysis</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {recaps.map((recap) => (
          <Card key={recap.id} className="overflow-hidden hover:shadow-lg transition-shadow">
            <div className="relative">
              <img 
                src={recap.thumbnail} 
                alt={recap.title}
                className="w-full h-48 object-cover"
              />
              <div className="absolute inset-0 bg-black/20 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity">
                <Button size="lg" className="rounded-full">
                  <Play className="h-6 w-6 mr-2" />
                  Watch Now
                </Button>
              </div>
              <div className="absolute bottom-2 right-2 bg-black/70 text-white px-2 py-1 rounded text-sm">
                {recap.duration}
              </div>
            </div>
            
            <CardHeader>
              <CardTitle className="text-lg">{recap.title}</CardTitle>
            </CardHeader>
            
            <CardContent className="space-y-3">
              <p className="text-gray-600 text-sm">{recap.description}</p>
              
              <div className="flex items-center justify-between text-sm text-gray-500">
                <div className="flex items-center space-x-1">
                  <Calendar className="h-4 w-4" />
                  <span>{new Date(recap.date).toLocaleDateString()}</span>
                </div>
                <div className="flex items-center space-x-1">
                  <Clock className="h-4 w-4" />
                  <span>{recap.views} views</span>
                </div>
              </div>
              
              <Button className="w-full">
                <Play className="h-4 w-4 mr-2" />
                Watch Recap
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default HoopsRecapsPage;